<template>
  <div class="pb24" v-loading="loading">
    <div v-if="tagData.length > 0">
      <dl class="yxtbiz-tag-dl" :key="index" v-for="(item, index) in tagData">
        <dt class="color-gray-10 font-size-14">
          <span class="font-medium">{{ item.groupName }}</span
          ><span class="color-gray-8"
            >（{{
              item.choiceType === 2
                ? $t('pc_biz_utility_tip_multiChoice')
                : $t('pc_biz_utility_tip_singleChoice')
            }}）</span
          >
        </dt>
        <dd>
          <tag-group
            :group-id="item.id"
            :multi="item.choiceType === 2"
            v-model="selected"
            :data="item.tags"
          ></tag-group>
        </dd>
      </dl>
    </div>
    <yxt-empty v-else />
  </div>
</template>

<script>
import { getTagSelectList } from './service';
import tagGroup from './tag-group';
import { Empty } from 'yxt-pc';
export default {
  components: {
    tagGroup,
    YxtEmpty: Empty
  },
  props: {
    module: {
      type: Number,
      required: true
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      tagData: [],
      loading: true,
      selected: this.value
    };
  },
  created() {
    getTagSelectList({ status: 1, tagType: this.module })
      .then(result => {
        let resData = result.datas.filter(item => !!item.id);
        resData && resData.length > 0 && resData.forEach(item => {
          item.tags && item.tags.length > 0 && item.tags.forEach(sitem => {
            sitem.groupName = item.groupName;
          });
        });
        this.tagData = resData;
        this.loading = false;
      })
      .then(e => {
        console.log(e);
      });
  },
  watch: {
    value(v) {
      this.selected = v;
    },
    selected(v) {
      this.$emit('input', v);
    }
  }
};
</script>

<style lang="scss" scoped></style>
